<div
  [ngClass]="{
    'block opacity-100': isSidebarOpen,
    'hidden opacity-0': !isSidebarOpen,
  }"
  (click)="toggleMenu()"
  class="fixed inset-0 z-20 bg-black bg-opacity-50 transition-opacity duration-300"
></div>

<div
  [ngClass]="{
    'translate-x-0': isSidebarOpen,
    '-translate-x-full': !isSidebarOpen,
  }"
  class="fixed top-0 z-30 !mt-0 !block h-full !min-h-0 w-full transform bg-[url('assets/media/bg-sidemenu.jpg')] bg-cover bg-bottom !pt-0 text-[#333333] transition-transform duration-300 md:w-3/4"
>
  <div class="pb-3">
    <div class="flex h-20 items-center px-5">
      <img
        (click)="setACtive('home'); toMenu('home')"
        class="w-32"
        src="assets/media/logo/logo-bcaexpo-2025-white.png"
        alt="Logo Expo"
      />
      <div class="ms-auto" (click)="toggleMenu()">
        <ion-icon color="light" name="close" size="large"></ion-icon>
      </div>
    </div>
    <div class="h-[calc(100vh_-_80px_-_72px)] overflow-y-auto px-5 py-2">
      <ul class="list-none p-0">
        @if (menu === 1) {
          <!-- <li class="px-[20px]">
          <a class="text-[#fff] flex items-center hover:text-[#FDBB20] no-underline active:text-[#FDBB20]"
            routerLink="/countdown" (click)="toMenu('countdown')">
            <span class="mr-auto" [ngClass]="{'h-active' : current == 'menu'}">Countdown</span>
          </a>
          </li> -->
          <!-- <hr class="my-[12px]"> -->
          <ion-item
            detail="false"
            (click)="toggleMenu()"
            routerLink="/home"
            class="analytic ion-no-padding ion-no-border bg-none"
            data-analytic="btn-menu-area"
          >
            <ion-label
              class="font-semibold"
              color="white"
              [class]="position_mobile === 'home' ? 'active' : ''"
              >Beranda</ion-label
            >
          </ion-item>
          <div
            *ngIf="isEventStart"
            class="clp-item-menu flex cursor-pointer items-center"
            (click)="isCollapsedMenu1 = !isCollapsedMenu1"
          >
            <p
              class="mb-0 font-semibold"
              [class]="position_mobile === 'produk' ? 'active' : ''"
            >
              Produk
            </p>
            <ion-icon
              *ngIf="!isCollapsedMenu1"
              name="chevron-down"
              class="small ms-auto"
              color="white"
            >
            </ion-icon>
            <ion-icon
              *ngIf="isCollapsedMenu1"
              name="chevron-up"
              class="small ms-auto"
              color="white"
            >
            </ion-icon>
          </div>
          <div *ngIf="isCollapsedMenu1">
            <div>
              <div class="card-body">
                <div
                  class="clp-item flex items-center"
                  (click)="toMenu('/kpr/home')"
                  data-analytic="btn-menu-area"
                >
                  <!-- <img src="assets/icon/icon-kpr.png" style="width: 40px" /> -->
                  <div class="ms-0">
                    <h6 class="mb-0 cursor-pointer font-bold">KPR BCA</h6>
                    <ion-text color="white">
                      <p class="mb-0">Solusi hunian ideal dengan KPR BCA</p>
                    </ion-text>
                  </div>
                </div>
                <div
                  class="clp-item flex items-center"
                  (click)="toMenu('/kkb/home')"
                  data-analytic="btn-menu-kpr"
                >
                  <!-- <img src="assets/icon/icon-kkb.png" style="width: 40px" /> -->
                  <div class="ms-0">
                    <h6 class="mb-0 cursor-pointer font-bold">KKB BCA</h6>
                    <ion-text color="white">
                      <p class="mb-0">Miliki mobil impian dengan KKB BCA</p>
                    </ion-text>
                  </div>
                </div>
                <div
                  class="clp-item flex items-center"
                  (click)="toMenu('/ksm/home')"
                  data-analytic="btn-menu-kkb"
                >
                  <!-- <img src="assets/icon/icon-ksm.png" style="width: 40px" /> -->
                  <div class="ms-0">
                    <h6 class="mb-0 cursor-pointer font-bold">KSM BCA</h6>
                    <ion-text color="white">
                      <p class="mb-0">
                        Pembiayaan sepeda motor dengan angsuran lebih ringan
                      </p>
                    </ion-text>
                  </div>
                </div>
                <div
                  class="clp-item flex items-center"
                  (click)="toMenu('/solusi/home')"
                  data-analytic="btn-menu-solusi"
                >
                  <!-- <img src="assets/icon/icon-solusi.png" style="width: 40px" /> -->
                  <div class="ms-0">
                    <h6 class="mb-0 cursor-pointer font-bold">Solusi BCA</h6>
                    <ion-text color="white">
                      <p class="mb-0">
                        Temukan penawaran produk dan layanan BCA untuk Anda
                      </p>
                    </ion-text>
                  </div>
                </div>
                <div
                  class="clp-item flex items-center"
                  (click)="toMenu('/solusi/solusi-pembiayaan-bisnis')"
                  data-analytic="btn-menu-solusi"
                >
                  <!-- <img
                    src="assets/icon/icon-pembiayaan.png"
                    style="width: 40px"
                  /> -->
                  <div class="ms-0">
                    <h6 class="mb-0 cursor-pointer font-bold">
                      Solusi Pembiayaan Bisnis
                    </h6>
                    <ion-text color="white">
                      <p class="mb-0">
                        Kembangkan usaha Anda dengan solusi pembiayaan BCA
                      </p>
                    </ion-text>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            *ngIf="isEventStart"
            class="clp-item-menu hidden cursor-pointer items-center"
            (click)="isCollapsedMenuOfflineEvent = !isCollapsedMenuOfflineEvent"
          >
            <p
              class="mb-0 font-semibold"
              [class]="position_mobile === 'offline-event' ? 'active' : ''"
            >
              Offline Event
            </p>
            <ion-icon
              *ngIf="!isCollapsedMenuOfflineEvent"
              name="chevron-down"
              class="small ms-auto"
              color="white"
            >
            </ion-icon>
            <ion-icon
              *ngIf="isCollapsedMenuOfflineEvent"
              name="chevron-up"
              class="small ms-auto"
              color="white"
            >
            </ion-icon>
          </div>
          <div *ngIf="isCollapsedMenuOfflineEvent">
            <div>
              <div class="card-body">
                <div
                  class="clp-item flex items-center"
                  (click)="toMenu('/offline-event')"
                  data-analytic="btn-menu-tutorial"
                >
                  <!-- <img
                    src="assets/icon/icon-menu-info.png"
                    style="width: 40px"
                  /> -->
                  <div class="ms-2">
                    <h6 class="pointer mb-0">Informasi BCA Expoversary</h6>
                  </div>
                </div>
                <div
                  class="clp-item flex items-center"
                  (click)="toMenu('/expo-lainnya')"
                  data-analytic="btn-menu-faq"
                >
                  <!-- <img
                    src="assets/icon/icon-menu-kotalain.png"
                    style="width: 40px"
                  /> -->
                  <div class="ms-2">
                    <h6 class="pointer mb-0">BCA Expoversary dikotamu</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ion-item
            *ngIf="isEventStart"
            detail="false"
            (click)="toggleMenu()"
            routerLink="/article"
            class="analytic ion-no-padding ion-no-border bg-none"
            data-analytic="btn-menu-article"
          >
            <ion-label
              class="font-semibold"
              color="white"
              [class]="position_mobile === 'article' ? 'active' : ''"
              >Media</ion-label
            >
          </ion-item>
          <!-- <ion-item
            *ngIf="isEventStart"
            detail="false"
            (click)="toggleMenu()"
            routerLink="/virtual-bidding"
            class="analytic ion-no-padding ion-no-border bg-none"
            data-analytic="btn-menu-article"
          >
            <ion-label
              class="font-semibold"
              color="white"
              [class]="position_mobile === 'virtual-bidding' ? 'active' : ''"
              >Virtual Bidding</ion-label
            >
          </ion-item> -->
          <div
            *ngIf="isEventStart"
            class="clp-item-menu flex cursor-pointer items-center"
            (click)="isCollapsedMenuInfo = !isCollapsedMenuInfo"
          >
            <p
              class="mb-0 font-semibold"
              [class]="position_mobile === 'faq' ? 'active' : ''"
            >
              Bantuan
            </p>
            <ion-icon
              *ngIf="!isCollapsedMenuInfo"
              name="chevron-down"
              class="small ms-auto"
              color="white"
            >
            </ion-icon>
            <ion-icon
              *ngIf="isCollapsedMenuInfo"
              name="chevron-up"
              class="small ms-auto"
              color="white"
            >
            </ion-icon>
          </div>
          <div *ngIf="isCollapsedMenuInfo">
            <div>
              <div class="card-body">
                <div
                  class="clp-item flex items-center"
                  (click)="toSurvey()"
                  data-analytic="btn-menu-tutorial"
                >
                  <!-- <img
                    src="assets/icon/icon-menu-surveyonline.png"
                    style="width: 40px"
                  /> -->
                  <div class="ms-0">
                    <h6 class="mb-0 cursor-pointer font-bold">Survei Online</h6>
                  </div>
                </div>
                <div
                  class="clp-item flex items-center"
                  (click)="toSurveyOffline()"
                  data-analytic="btn-menu-faq"
                >
                  <!-- <img
                    src="assets/icon/icon-menu-surveyoffline.png"
                    style="width: 40px"
                  /> -->
                  <div class="ms-0">
                    <h6 class="mb-0 cursor-pointer font-bold">
                      Survei Offline
                    </h6>
                  </div>
                </div>
                <div
                  class="clp-item hidden items-center"
                  (click)="toMenu('/tutorial')"
                  data-analytic="btn-menu-tutorial"
                >
                  <!-- <img src="assets/icon-tutorial.svg" style="width:40px" /> -->
                  <!-- <img
                    src="assets/icon/icon-tutorial.png"
                    style="width: 40px"
                  /> -->
                  <div class="ms-0">
                    <h6 class="mb-0 cursor-pointer font-bold">Tutorial</h6>
                  </div>
                </div>
                <div
                  class="clp-item flex items-center"
                  (click)="toMenu('/faq')"
                  data-analytic="btn-menu-faq"
                >
                  <!-- <img src="assets/icon-faq.svg" style="width:40px" /> -->
                  <!-- <img src="assets/icon/icon-faq.png" style="width: 40px" /> -->
                  <div class="ms-0">
                    <h6 class="mb-0 cursor-pointer font-bold">FAQ</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ion-item
            *ngIf="isLogin"
            detail="false"
            (click)="toggleMenu()"
            routerLink="/favorite"
            class="analytic ion-no-padding ion-no-border bg-none"
            data-analytic="btn-menu-informasi"
          >
            <ion-label color="white" class="font-semibold">Favorite</ion-label>
          </ion-item>
          <ion-item
            *ngIf="isLogin"
            detail="false"
            (click)="toggleMenu()"
            routerLink="/notification"
            class="analytic ion-no-padding ion-no-border bg-none"
            data-analytic="btn-menu-informasi"
          >
            <ion-label color="white" class="font-semibold"
              >Notifikasi</ion-label
            >
          </ion-item>
          <ion-item
            *ngIf="isLogin"
            detail="false"
            (click)="toggleMenu()"
            routerLink="/profile"
            class="analytic ion-no-padding ion-no-border bg-none"
            data-analytic="btn-menu-informasi"
          >
            <ion-label color="white" class="font-semibold">Profile</ion-label>
          </ion-item>
        } @else {
          <ion-item
            detail="false"
            (click)="toggleMenu()"
            routerLink="/home"
            class="analytic ion-no-padding ion-no-border bg-none"
            data-analytic="btn-menu-area"
          >
            <ion-label
              class="font-semibold"
              color="white"
              [class]="position_mobile === 'home' ? 'active' : ''"
              >Beranda</ion-label
            >
          </ion-item>
          <ion-item
            *ngIf="isLogin"
            detail="false"
            (click)="toggleMenu()"
            routerLink="/profile"
            class="analytic ion-no-padding ion-no-border bg-none"
            data-analytic="btn-menu-informasi"
          >
            <ion-label color="white" class="font-semibold">Profile</ion-label>
          </ion-item>
        }
      </ul>
      <div class="mb-5 pt-3" *ngIf="!isLogin">
        <ion-button
          mode="ios"
          expand="block"
          color="primary"
          routerLink="/register"
          (click)="analyticClickAction('btn-register'); toggleMenu()"
        >
          <ion-text class="font-bold"> Masuk Event </ion-text>
        </ion-button>
      </div>
      <div *ngIf="isLogin" (click)="toggleMenu()" class="mb-5">
        <ion-button
          mode="ios"
          class="btn-white-outline"
          (click)="logout(); analyticClickAction('btn-logout')"
        >
          Logout
        </ion-button>
      </div>
    </div>
    @if (isLogin) {
      <div class="flex w-full cursor-pointer items-center px-5 pb-5">
        <ion-avatar
          class="small transparent-light flex-shrink-0 cursor-pointer"
        >
          {{ getInitial() }}
        </ion-avatar>
        <div class="ms-3 w-full">
          <div
            class="running-text w-full overflow-hidden whitespace-nowrap font-bold capitalize text-white"
          >
            <div id="text1">Hi, {{ auth.users()?.name }}</div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
